export default {
  init() {
    $(".overview-link").on("click", function (event) {
      event.preventDefault();
      $(".overview-link").each(function () {
        $(this).removeClass("active");
      });
      $(".overview-details").each(function () {
        $(this).removeClass("active");
      });
      $(this).addClass("active");
      var detail = $(this).data("for");
      $("." + detail).addClass("active");
    });
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/overview.js